module.exports = __webpack_public_path__ + "img/yellow-pending-circle.81023715.svg";